<div class="container-fluid pb-5 bg-light">
  <!-- Page Header -->
  <div class="mb-4">
    <h3 class="fw-bold text-dark">
      <span class="lstick"></span> Charity Settlements Details
    </h3>
  </div>

  <div *ngIf=" details">

    <div class="card mb-4 shadow-sm">
      <h4 class="card-header fw-bold">Transaction Summary</h4>
      <div class="card-body row">
        <div class="col-md-4"><b>Total Orders:</b> {{ details.totalOrders }}</div>
        <div class="col-md-4"><b>Total Charity Amount:</b> {{ details.totalDonationAmount }}</div>
        <div class="col-md-4">
          <b>Status: </b>
          <span class="badge" [ngClass]="details.status === 'paid' ? 'bg-success' : 'bg-warning text-dark'">
            {{ details.status === 'paid' ? 'Paid' : details.status === 'pending' ? 'Pending' : 'Processing' }}
          </span>
        </div>
        <div class="col-md-4">
          <b>Month / Year:</b>
          {{ details.month }}/{{ details.year }}
        </div>

        <div class="col-md-4 mt-2"><b>Created Date:</b> {{ details.created_at | date:'medium' }}</div>
      </div>
    </div>

    <div class="card shadow-sm">
      <h4 class="card-header fw-bold"> Transactions ({{ details.transactionIds?.length || 0 }})
      </h4>
      <div class="table-responsive">
        <table class="table table-bordered mb-0">
          <thead class="table-light">
            <tr>
              <th>#</th>
              <th>Order Number</th>
              <th>Invoice</th>
              <th>Charity Percentage</th>
              <th>Charity Amount</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tx of details.transactionIds; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ tx.orderNumber }}</td>
              <td>{{ tx.invoice_number }}</td>
              <td>{{ tx.donationPercentage }}%</td>
              <td>{{ tx.amount }} {{ currency }}</td>
              <td>
                <span class="badge" [ngClass]="tx.isPaid ? 'bg-success' : 'bg-warning text-dark'">
                  {{ tx.isPaid ? 'Paid' : 'Pending' }}
                </span>
              </td>
              <td>{{ tx.created_at | date:'short' }}</td>
            </tr>

            <tr *ngIf="!details.transactionIds?.length">
              <td colspan="7" class="text-center text-muted">
                No transactions found
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="loading" class="text-center mt-5">
      <div class="spinner-border text-primary"></div>
    </div>
  </div>